export const UserType = {
  ADMINISTRADOR: "Administrador",
  CLIENTE: "Cliente",
  REPRESENTANTE: "Representante",
  DISTRIBUIDOR: "Distribuidor",
  FABRICA: "Fábrica"
}